<template>
  <div class="controls">
    <a-form class="form" layout="vertical" :model="formState">
      <a-form-item name="ivr" label="Nombre del IVR" required>
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          v-model:value="formState.ivr"
          placeholder="Selecciona un IVR"
        >
          <a-select-option v-for="ivr in ivrs" :key="ivr.id">{{ ivr.name }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item name="date" label="Fecha" required>
        <plan-range-picker
          v-model="formState.date"
          :config-key="RangeConfigKey.MessagingSearchRange" />
      </a-form-item>
    </a-form>

    <a-button type="primary" :disabled="isDisabled" @click="handleDownload">
      Descargar
      <DownloadOutlined />
    </a-button>
  </div>

  <section class="empty">Este reporte solo se podrá descargar al aplicar los filtros</section>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref, watch } from "vue";
import { DownloadOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";

import { Bot } from "@/@types/ivr";
import { botServices } from "@/app/ivr/bot/services/BotServices";
import { BotStatus, BotType } from "@/app/ivr/bot/utils/enums";
import { ReportTypes } from "../../utils/enums";
import { ivrReportService } from "@/app/reports/services/IvrReportService";
import { RangeConfigKey } from "@/app/shared/utils/planDatePicker";

import PlanRangePicker from "@/app/shared/components/pickers/PlanRangePicker.vue";

const props = defineProps<{ report: number }>();

const formState = reactive({
  ivr: undefined,
  date: ["", ""],
});

const ivrs = ref<Bot[]>([]);

const isDisabled = computed(() => !formState.ivr || !formState.date[0] || !formState.date[1]);

onMounted(async () => {
  await fetchIvrLis();
});

const fetchIvrLis = async () => {
  try {
    ivrs.value = await botServices.getList({
      status: BotStatus.Active,
      type: props.report === ReportTypes.IvrAutomatic ? BotType.Automatic : BotType.Survey,
    });
  } catch (error) {
    message.error("Error al cargar lista de ivr");
    console.error(error);
  }
};

watch(
  () => props.report,
  async () => {
    await fetchIvrLis();
  }
);

const handleDownload = async () => {
  await ivrReportService.download(props.report, formState);
};
</script>

<style scoped lang="sass">
.controls
  display: flex
  justify-content: space-between
  align-items: center
  margin-top: 15px

.form
  display: flex
  justify-content: space-between
  align-items: center
  gap: 16px

.empty
  font-size: 20px
  color: $gray-7
  text-align: center
</style>
